import { atom } from 'recoil';

export const aSetTopicDialog = atom<boolean>({ key: 'aSetTopicDialog', default: true });
export const aShowTopic = atom<boolean>({ key: 'aShowTopic', default: false });
export const aSetTopic = atom<any>({ key: 'aSetTopic', default: localStorage.getItem('topicTitle') || '' });
